import { motion } from "framer-motion";
import { Globe2, MapPin, Languages, Monitor } from "lucide-react";

const regions = [
  {
    title: "México",
    items: ["Ciudad de México", "Monterrey", "Guadalajara", "Todo el territorio nacional"],
  },
  {
    title: "Centroamérica",
    items: ["Guatemala", "El Salvador", "Honduras", "Nicaragua", "Costa Rica", "Panamá", "Belice"],
  },
  {
    title: "Sudamérica",
    items: ["Colombia", "Ecuador", "Perú", "Chile", "Resto de Latinoamérica"],
  },
  {
    title: "Estados Unidos",
    items: ["Phoenix, Arizona (base local)", "Cobertura nacional", "Atención en inglés y español"],
  },
];

const notes = [
  { icon: Monitor, text: "Implementación remota o presencial según tu ubicación" },
  { icon: Languages, text: "Consultoría y capacitación en español e inglés" },
  { icon: MapPin, text: "Base operativa en Guatemala y en Phoenix, Arizona" },
];

const CoverageSection = () => (
  <section id="cobertura" className="py-24 section-gradient">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center max-w-3xl mx-auto mb-14"
      >
        <span className="text-sm font-semibold tracking-wider uppercase text-primary mb-3 block">
          Cobertura
        </span>
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
          Distribuidor autorizado de DocuWare para Latinoamérica y Estados Unidos
        </h2>
        <p className="text-muted-foreground text-lg leading-relaxed">
          Estamos autorizados para comercializar, implementar y dar soporte a DocuWare en toda
          Latinoamérica —incluyendo México, Centroamérica y Sudamérica— y en Estados Unidos, con
          presencia local en Guatemala y en Phoenix, Arizona.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {regions.map((region, i) => (
          <motion.div
            key={region.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.1 }}
            className="glass glass-hover rounded-2xl p-8"
          >
            <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mb-5">
              <Globe2 size={24} className="text-accent-foreground" aria-hidden="true" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-4">{region.title}</h3>
            <ul className="space-y-2">
              {region.items.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
        {notes.map(({ icon: Icon, text }) => (
          <div key={text} className="flex items-center gap-3 rounded-xl border border-border bg-card p-4">
            <Icon size={20} className="text-primary shrink-0" aria-hidden="true" />
            <span className="text-sm text-muted-foreground">{text}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CoverageSection;
